import { Dialog, DialogContent, DialogOverlay, DialogPortal } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { useEffect } from "react";

interface CalendarPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const CalendarPopup = ({ isOpen, onClose }: CalendarPopupProps) => {
  // Lock body scroll when popup is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm" />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div 
            className="relative w-full max-w-6xl bg-white rounded-lg shadow-2xl"
          >
            <button
              onClick={onClose}
              className="absolute right-3 top-3 z-50 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
            >
              <X className="h-4 w-4 text-gray-600" />
              <span className="sr-only">Close</span>
            </button>
            <div className="w-full" style={{ height: '80vh' }}>
              <iframe
                src="https://api.storily.io/widget/booking/uBp25MxekY7BYVaERAqS"
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  border: 'none',
                  borderRadius: '8px'
                }}
                title="Book a Strategy Call"
                allow="payment"
              />
            </div>
          </div>
        </div>
      </DialogPortal>
    </Dialog>
  );
};

export default CalendarPopup;